import { MessageSquare, ChevronDown } from 'lucide-react';
import { CONTACT_INFO } from '../data/content';

export const Hero = () => {
  
    const handleTicketClick = (e) => {
    const ticketId = Math.floor(1000 + Math.random() * 9000);
    const subject = encodeURIComponent(`Support Inquiry - Ticket #${ticketId}`);
    
    // Update the link href dynamically upon click
    e.currentTarget.href = `mailto:${CONTACT_INFO.email}?subject=${subject}`;
  }
  return(
  <section id="hero" className="pt-32 pb-20 px-6 max-w-7xl mx-auto text-center md:text-left flex flex-col md:flex-row items-center gap-12">
    <div className="flex-1">
      <div className="inline-block px-3 py-1 bg-blue-500/10 text-blue-400 rounded-full text-xs font-bold tracking-widest mb-6">ONE TEAM. ZERO FRICTION.</div>
      <h1 className="text-4xl md:text-6xl font-extrabold text-white leading-tight mb-6">
        Your IT challenges don’t need multiple vendors — <span className="text-blue-500">you need one solid team.</span>
      </h1>
      <p className="text-lg text-slate-400 mb-10 max-w-xl">
        A specialized squad of IT specialists keeping your systems stable, secure, and high-performing.
      </p>
      <div className="flex flex-col sm:flex-row gap-4">
        <a 
          href={`mailto:${CONTACT_INFO.email}`}
          onClick={handleTicketClick} className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-xl font-bold flex items-center justify-center gap-2 transition shadow-xl shadow-blue-900/40">
          <MessageSquare size={20} /> OPEN A TICKET
        </a>
      </div>
    </div>
    <div className="flex-1 hidden md:block">
       <div className="relative p-8 bg-slate-800/30 rounded-3xl border border-slate-700 backdrop-blur-sm">
          <div className="flex items-center gap-2 mb-4"><div className="w-3 h-3 rounded-full bg-red-500"/><div className="w-3 h-3 rounded-full bg-yellow-500"/><div className="w-3 h-3 rounded-full bg-green-500"/></div>
          <code className="text-blue-300 text-sm font-mono block">
            $ check_system_health --all<br/>
            <span className="text-green-400">STATUS: STABLE</span><br/>
            <span className="text-green-400">SECURITY: HARDENED</span><br/>
            <span className="text-green-400">UPTIME: 99.9%</span><br/>
            $ _
          </code>
       </div>
    </div>

    {/* Animated Scroll Down Button */}
    <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce hidden md:block">
      <a href="#offer" className="text-slate-500 hover:text-blue-400 transition-colors">
        <ChevronDown size={32} />
      </a>
    </div>
  </section>
);
};